const MAX_ITEM_NUMBER_ABS = '999999999999999';

function normalizedIntegerPart(value) {
    const normalized = value.replace(/^0+(?=\d)/, '');
    return normalized === '' ? '0' : normalized;
}

function isWithinMaximum(integerPart, fractionPart) {
    const normalized = normalizedIntegerPart(integerPart);
    if (normalized.length !== MAX_ITEM_NUMBER_ABS.length) {
        return normalized.length < MAX_ITEM_NUMBER_ABS.length;
    }
    if (normalized < MAX_ITEM_NUMBER_ABS) {
        return true;
    }
    return normalized === MAX_ITEM_NUMBER_ABS && !/[1-9]/.test(fractionPart);
}

export function isValidItemDecimal(value, allowNegative, maximumFractionDigits) {
    const text = String(value).trim();
    const signPattern = allowNegative ? '-?' : '';
    const match = new RegExp('^' + signPattern + '(\\d+)(?:\\.(\\d+))?$').exec(text);
    if (match === null) {
        return false;
    }
    const fraction = match[2] || '';
    return fraction.length <= maximumFractionDigits && isWithinMaximum(match[1], fraction);
}

export function setItemDecimalSign(value, sign) {
    const text = String(value).trim();
    const magnitude = text.charAt(0) === '-' ? text.substring(1) : text;
    if (magnitude === '') {
        return '';
    }
    if (/^0+(?:\.0+)?$/.test(magnitude)) {
        return magnitude;
    }
    return sign === -1 ? '-' + magnitude : magnitude;
}

export function itemDecimalSign(value) {
    return String(value).trim().charAt(0) === '-' ? -1 : 1;
}

export function isValidItemUnit(value) {
    const unit = String(value == null ? '' : value).trim();
    return unit.indexOf('&&') === -1;
}

export {MAX_ITEM_NUMBER_ABS};
